import { types } from 'mobx-state-tree';
import { PolylineGeometry } from './polyline';
import { TAPlanGeometryAttributes } from './taGeometryAttributes';

const TAPolyline = types
  .model('TAPolyline', {
    polyline: types.maybe(PolylineGeometry)
  })
  .actions(self => ({
    update: graphic => {
      self.comment = graphic.attributes.comment;
      self.snapshotIndex = graphic.attributes.snapshotIndex;
      self.polyline = graphic.geometry.toJSON();
    }
  }));

export const TARegulationPolyline = types.compose(TAPlanGeometryAttributes, TAPolyline).named('TARegulationPolyline');
